import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DefinitionsEditorModule } from '@barthauer/abc/queries/parameters/definitions-editor';
import { AbcAccordionComponent } from '@barthauer/abc/ui-components/abc-accordion';
import { _AbcButtonComponent } from '@barthauer/abc/ui-components/abc-button';
import { _AbcCheckBoxComponent } from '@barthauer/abc/ui-components/abc-check-box';
import { AbcDateBoxComponent } from '@barthauer/abc/ui-components/abc-date-box';
import { AbcDropDownBoxComponent } from '@barthauer/abc/ui-components/abc-drop-down-box';
import { AbcDropDownBoxButtonComponent } from '@barthauer/abc/ui-components/abc-drop-down-box-button';
import { _AbcFileUploaderComponent } from '@barthauer/abc/ui-components/abc-file-uploader';
import { AbcListComponent } from '@barthauer/abc/ui-components/abc-list';
import { AbcLoadIndicatorComponent } from '@barthauer/abc/ui-components/abc-load-indicator';
import { AbcNumberBoxComponent } from '@barthauer/abc/ui-components/abc-number-box';
import { _AbcScrollViewComponent } from '@barthauer/abc/ui-components/abc-scroll-view';
import { _AbcSelectBoxComponent } from '@barthauer/abc/ui-components/abc-select-box';
import { _AbcSplitterComponent } from '@barthauer/abc/ui-components/abc-splitter';
import { _AbcTextAreaComponent } from '@barthauer/abc/ui-components/abc-text-area';
import { AbcTextBoxComponent } from '@barthauer/abc/ui-components/abc-text-box';
import { _AbcTreeComponent } from '@barthauer/abc/ui-components/abc-tree';
import { DxDropDownButtonModule, DxScrollViewModule, DxTemplateModule, DxValidatorModule } from 'devextreme-angular';
import { CoreModule } from '../../../core/src/lib/core.module';
import { EntityComponent } from './core/entity/entity.component';
import { FunctionComponent } from './core/function/function.component';
import { MenuComponent } from './core/menu/menu.component';
import { NavigationComponent } from './core/navigation/navigation.component';
import { OperatorsComponent } from './core/operators/operators.component';
import { SearchComponent } from './core/search/search.component';
import { ValidateComponent } from './core/validate/validate.component';
import { ExpressionsEditorComponent } from './expressions-editor.component';

@NgModule({
  declarations: [
    SearchComponent,
    ValidateComponent,
    EntityComponent,
    ExpressionsEditorComponent,
    FunctionComponent,
    MenuComponent,
    NavigationComponent,
    OperatorsComponent,
  ],
  exports: [ExpressionsEditorComponent],
  providers: [],
  imports: [
    DefinitionsEditorModule,
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    DxScrollViewModule,
    DxTemplateModule,
    FlexLayoutModule,
    _AbcButtonComponent,
    AbcAccordionComponent,
    _AbcCheckBoxComponent,
    AbcDateBoxComponent,
    DxValidatorModule,
    DxDropDownButtonModule,
    AbcLoadIndicatorComponent,
    _AbcTreeComponent,
    AbcTextBoxComponent,
    _AbcTextAreaComponent,
    _AbcFileUploaderComponent,
    _AbcSplitterComponent,
    _AbcSelectBoxComponent,
    AbcDropDownBoxComponent,
    AbcNumberBoxComponent,
    AbcListComponent,
    _AbcScrollViewComponent,
    AbcDropDownBoxButtonComponent,
    CoreModule,
  ],
})
export class ExpressionsEditorModule {}
